import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {InterfaceService} from "@app/interfaces";
import {BehaviorSubject, Observable, of, Subject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class JobSidebarService extends InterfaceService {

    refreshAssignedUsers = new BehaviorSubject(null);
    refreshAssignedUsers$ = this.refreshAssignedUsers.asObservable();

    private refreshJobDetailsSubject = new Subject<number | void>();
    refreshJobDetails$ = this.refreshJobDetailsSubject.asObservable();
    private refreshJobFinanceSubject = new Subject<number | void>();
    refreshJobFinance$ = this.refreshJobFinanceSubject.asObservable();

    constructor(private http: HttpClient) {
        super();
    }

    getJobDetails(type: string, id: number, jobId: number): Observable<any> {
        return this.http.get(this.getJobApiUrl(`customers/${type}/${id}/jobs/${jobId}/details/view`));
    }

    getJobFinancialPerformance(type: string, id: number, jobId: number): Observable<any> {
        return this.http.get(this.getJobApiUrl(`customers/${type}/${id}/jobs/${jobId}/financial-performance/view`));
    }

    getAssets(propertyId: number, jobId: number, screenType: string): Observable<any> {
        return this.http.get(this.getJobApiUrl(`job_assets?propertyId=${propertyId}&jobId=${jobId}&screenType=${screenType}`));
    }

    saveJobStages = function (data, jobId) {
        return this.http.post(this.getApiUrl(`save_job_stages/${jobId}`), JSON.stringify(data));
    };

    saveJobTeam = function (data, jobId) {
        return this.http.post(this.getApiUrl(`save_job_team/${jobId}`), JSON.stringify(data));
    };
    saveJobTeamUsers = function (data, jobId) {
        return this.http.post(this.getApiUrl(`save_job_team_users/${jobId}`), JSON.stringify(data));
    };

    saveTeamMembersList = function (teamId) {
        return this.http.post(this.getApiUrl(`get_team_members/${teamId}`));
    };

    getCustomerJobAssets(type: string, id: number,jobAssetIds,jobId, data){
        const params = {
            page: data.reqParams.page.toString(),
            limit: data.reqParams.limit.toString(),
            searchText: data.reqParams.searchText,
            sort: data.reqParams.sort || '',
            filters: data.reqParams.filters,
            jobId: jobId
        };
        return this.http.get(this.getJobApiUrl(`customers/${type}/${id}/assets/list`),{params});
    }

    getAssetsColumns(propertyId: number, screenType: string): Observable<any> {
        return this.http.get(this.getApiUrl(`customers/${screenType}/${propertyId}/assets/views`));
    }

    removeAssetFromJob(jobAssetId:number, jobId:number){
        return this.http.get(this.getJobApiUrl(`remove_job_asset/${jobAssetId}/job/${jobId}`));
    }


    setAssignedUsers(data) {
        this.refreshAssignedUsers.next(data);
    }

    /** Notify sidebar to refresh job details (e.g. after cost summary update). Pass jobId to refresh only that job's sidebar. */
    notifyJobDetailsRefresh(jobId?: number) {
        this.refreshJobDetailsSubject.next(jobId != null ? jobId : undefined);
    }

    notifyJobFinanceRefresh(jobId?: number) {
        this.refreshJobFinanceSubject.next(jobId != null ? jobId : undefined);
    }

    retrieveAppliedUsers(jobId:number){
        return this.http.get(this.getJobApiUrl(`saved_users/${jobId}`));
    }

    getDiaryFeedbackById(opportunityId, screenType) {
        return this.http.get(this.getApiUrl(`get_diary_event_feedback_by_id/${opportunityId}/${screenType}`));
    }

}
